import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { HttpService } from '../../services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../services/loader/loader.service';
import { HelperService } from '../../util/helper/helper.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from '../../../environments/environment';
import { FirebaseMiddlewareService } from '../../services/firebase-middleware/firebase-middleware.service';
import * as _ from 'underscore';
import * as moment from 'moment'
/**
 * This is a common service to communicate between the components
 */
@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  boardListner;
  constructor(private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    public auth: AngularFireAuth,
    private afs: AngularFirestore,
    private helper: HelperService,
    private firebaseMiddlewareService: FirebaseMiddlewareService) { }

  private sidebar = new BehaviorSubject<any>(false)
  public sidebarMenu = this.sidebar.asObservable();
  /**
   * This function is used to toggle the side menu
   * @param payload 
   */
  toggleSidebarMenu(payload) {
    this.sidebar.next(payload);
  }

  private search = new BehaviorSubject<any>({});
  public searchPatient = this.search.asObservable();

  /**
   * This function gets called when the user clicks on the search button, This function indicates that whether search is start or stop
   * @param payload 
   */
  onSearch(payload) {
    this.search.next(payload);
  }

  /**
   * This function is use to fetch all Active boards from the firebase
   */
  getBoard() {
    return new Promise(resolve => {
      this.loader.show('progress');
      const fireAuthListener = this.auth.authState.subscribe(isAuthenticated => {
        if (isAuthenticated) {
          fireAuthListener.unsubscribe();
          this.boardListner = this.afs.collection("QueueBoard", ref => ref.where("status", '==', 'Active').orderBy('meta.lastUpdated')).valueChanges().subscribe((boards: any) => {
            this.setBoardData(boards);
            this.loader.hide('progress');
            resolve(true)
          })
        } else {
          resolve(false)
        }
      })
    })
  }

  private boards = new BehaviorSubject<any>([])
  public getBoards = this.boards.asObservable();
  /**
   * This function is use to set the board data, this data will be used in sidebar component 
   * @param payload 
   */
  setBoardData(payload) {
    payload.map(x => {
      let name = x.boardName.toLowerCase();
      name = name.trim();
      x.routeName = name.replace(/\s/g, '-');
    })
    this.boards.next(payload);
    return payload;
  }

  private labels = new BehaviorSubject<any>([])
  public getLabels = this.labels.asObservable();

  /**
   * This method is used to set the lable data, this data will be used in label popup
   * @param payload 
   */
  setLabels(payload) {
    this.labels.next(payload);
  }

  endpoints = [];
  /**
   * This function is used to get all the templates from FHIR and show this in the email template and print template
   */
  getAllTemplates() {
    this.loader.hide('progress');
    this.httpService.get('template')
      .subscribe((response: any) => {
        this.loader.hide('progress');
        response.map(x => {
          if (x.thumbnailImage)
            this.endpoints.push(this.httpService.get(`media/${this.helper.extractId(x.thumbnailImage)}`));
        })
        this.getThumbnail(response);
      }, error => {
        this.loader.hide('progress');
        this.toastr.warning(error, '', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  /**
   * This function is used to generate the thumbnail email for print templates
   * @param templates 
   */
  getThumbnail(templates) {
    if (this.endpoints.length) {
      forkJoin(this.endpoints).subscribe((results: any) => {
        results.map(x => {
          const index = templates.findIndex(y => y.thumbnailImage && this.helper.extractId(y.thumbnailImage) === x.id);
          if (index !== -1)
            templates[index].src = `data:${x.content.contentType};base64,${x.content.data}`;
          this.endpoints = [];
        })
        this.setTemplates(templates);
      }, error => {
        this.loader.hide('progress');
        this.toastr.warning(error, 'Media', {
          progressBar: true, timeOut: 3000
        });
      });
    } else {
      this.setTemplates(templates);
    }
  }

  private templates = new BehaviorSubject<any>([])
  public getTemplates = this.templates.asObservable();
  /**
   * This function is used to set templates in service
   * @param payload 
   */
  setTemplates(payload) {
    this.templates.next(payload);
  }

  private templateData = new BehaviorSubject<any>([])
  public getTemplateData = this.templateData.asObservable();
  allData = {};

  /**
   * This function is used to reset the template data
   */
  resetTemplateData() {
    this.allData = {};
  }

  /**
   * This function is used to set the data which will be used in template (eg. patient detail, assessment, and documents)
   * @param payload 
   * @param type 
   */
  setTemplateData(payload, type) {
    this.allData[type] = payload;
    this.templateData.next(this.allData);
  }

  private media = new BehaviorSubject<any>(false)
  public loadMedia = this.media.asObservable();
  /**
   * This function is used to set the media data
   * @param payload 
   */
  isLoadMedia(payload) {
    this.media.next(payload);
  }

  // private communications = new BehaviorSubject<any>([])
  // public getCommunications = this.communications.asObservable();

  // setCommunicationData(payload) {
  //   this.communications.next(payload);
  // }

  ngOnDestroy(): void {
    this.boardListner.unsubscribe();
    this.communicationListener.unsubscribe();
  }

  private filter = new BehaviorSubject<any>({
    searchText: '',
    labels: []
  })

  public getTaskFilter = this.filter.asObservable();

  setTaskFilter(payload) {
    this.filter.next(payload);
  }

  communicationListener;
  communications = [];
  private $communications = new BehaviorSubject<any>([])
  public allCommunications = this.$communications.asObservable();
  getCommunications() {
    const dt = moment(new Date()).subtract(parseInt(environment.communicationReadTime), 'days');
    const newDate = moment(dt).format();
    const fireAuthListener = this.auth.authState.subscribe(isAuthenticated => {
      if (isAuthenticated) {
        fireAuthListener.unsubscribe();
        this.communicationListener = this.afs.collection("Communication", ref => ref
          .where('status', '==', 'in-progress')
          .where('senderRole', '==', 'Patient')
          .orderBy('sent', 'desc')
          .endAt(newDate)).valueChanges().subscribe((communications: any) => {
            // Filter the new data based on conditions and old data
            this.communications = this.firebaseMiddlewareService.filterFirebaseData(this.communications, communications, [{ operator: 'neq', key: 'status' }], 'id', 'merge');
            // Get uniq data based on subject
            let uniqCommunication: any = _.groupBy(this.communications, (item: any) => item.subject && this.helper.extractId(item.subject));

            uniqCommunication = Object.entries(uniqCommunication).map((x: any) => { return { id: x[0], data: x[1] } });

            this.$communications.next(uniqCommunication);
          })
      }
    })
  }

  private dashCommunications = new BehaviorSubject<any>([])
  public getDashCommunications = this.dashCommunications.asObservable();
  dashboardCommunicatons = [];
  setDashboardCommunciation(payload) {
    if(payload.queueId)
      this.dashboardCommunicatons = this.dashboardCommunicatons.filter(x=> x.queueId!==payload.queueId);

    this.dashboardCommunicatons = [...this.dashboardCommunicatons, ...payload.communications];
    this.dashCommunications.next(this.dashboardCommunicatons);
  }

  resetDashboardCommunciation(){
    this.dashboardCommunicatons = [];
    this.dashCommunications.next([]);
  }

}
